"use strict";

var CustomForm = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/form',
    editGroupPermission: 'admin_forms',

    url: function() {
        var url = this.urlRoot + (this.id ? '/' + this.id : '');
        if (this.forJobId) url += '?job=' + this.forJobId;
        return url;
    },

    setFromTemplate: function(template) {
        this.set({
            fromTemplateId: template.id,
            title: template.get('title'),
            description: template.get('description'),
            instructions: template.get('instructions'),
            groupId: template.get('groupId'),
            requiredFields: template.get('requiredFields'),
            fields: template.get('fields'),
        }, {silent: true});
    },

    shareByEmail: function(emailAddress, message, shareInternalInfo, pdf) {
        var data = { to: emailAddress, message: message };
        if (shareInternalInfo) data.internal = true;
        if (pdf) data.pdf = true;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/share/email',
            type: 'POST',
            data: data
        });

    },

    hasReferenceValues: function() {
        var fields = this.get('fields');
        if (!fields) return false;
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].type == 'REFERENCE_VALUE') return true;
        }
        return false;
    },

    updateReferenceValues: function() {
        var fields = ['groupId', 'jobId', 'fields'];
        var data = {};
        var self = this;
        fields.forEach(function(field) { data[field] = self.get(field); });
        return $.ajax({
            url: Core.contextRoot + '/form/preview-reference-values',
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json',
            success: function(values) {
                var changed = false;
                var fields = self.get('fields');
                _(values).each(function (value, name) {
                    _(fields).each(function (field) {
                        if (field.name == name && field.value != value) {
                            field.value = value;
                            changed = true;
                        }
                    });
                });
                if (changed) self.set('fields', fields);
            }
        });
    }

});

var CustomForms = Backbone.Collection.extend({
    model: CustomForm,

    url: function() {
        // Build query from filter parameters
        var url;
        var params = { };
        if (this.filterParams.limit) params.limit = this.filterParams.limit;
        if (this.filterParams.offset) params.offset = this.filterParams.offset;
        if (this.filterParams.lastModified) params.lastModified = this.filterParams.lastmodified;
        if (this.searchQuery) {
            url = Core.contextRoot + '/form/search';
            params.q = this.searchQuery;
        } else {
            url = Core.contextRoot + '/form' + (this.filterParams.path ? '/' + this.filterParams.path : '');
            if (this.filterParams.path && this.filterParams.path == 'templates') {
                if (this.filterParams.includeDrafts) params.drafts = true;
            }
        }
        if (this.filterParams.from == null || typeof this.filterParams.from == 'undefined') {
            var fromDate = new Date();
            fromDate.setHours(0,0,0,0);
            this.filterParams.from = fromDate.getTime();
        }
        params.from = this.filterParams.from;
        if (this.filterParams.to)
            params.to = this.filterParams.to;
        var paramsStr = $.param(params);
        if (paramsStr.length > 0)
            url += '?' + paramsStr;
        return url;
    },

    initialize: function(models, options) {
        this.filterParams = {};
        if (options && options.filterParams)
            _(this.filterParams).extend(options.filterParams);
        else if ('forms.filterParams' in sessionStorage)
            this.filterParams = JSON.parse(sessionStorage['forms.filterParams']);
    },

    saveFilter: function() {
        sessionStorage['forms.filterParams'] = JSON.stringify(this.filterParams);
    }
});

CustomForms.filterCollection = function(filter, collection) {
    var filteredCollection = new CustomForms(collection);
    var formTemplateId, from, to;
    if (filter.formTemplate) {
        formTemplateId = filter.formTemplate;
    }
    if (filter.from && filter.to) {
        from = new Date(filter.from).getTime();
        to = new Date(filter.to).getTime();
    }
    
    if (formTemplateId) {
        filteredCollection.reset(filteredCollection.filter(function(form) {
            return form.get('fromTemplateId') == formTemplateId;
        }));
    }
    if (from && to) {
        filteredCollection.reset(filteredCollection.filter(function(form) {
            var stateTimeStamp = new Date(new Date(form.get('stateTimeStamp')).toString('yyyy-MM-dd')).getTime();
            if (form.get('state') == 'PUBLISHED') stateTimeStamp = new Date(new Date(form.get('lastModified')).toString('yyyy-MM-dd')).getTime();
            return stateTimeStamp >= from && stateTimeStamp <= to;
        }));
    }
    return filteredCollection;
}
